import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-3">
              Browse Categories
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-[500px]">
              Discover products organized by category for faster and easier browsing
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-100 rounded-full text-foreground-500 text-xs font-medium whitespace-nowrap">
            <i className="ri-time-line text-xs"></i>
            Updated 2026
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative block h-[280px] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name} - Superbuy Spreadsheet category`}
                title={`Superbuy Spreadsheet ${cat.name}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-[11px] font-medium mb-2">
                  {cat.name}
                </span>
                <div className="flex items-center gap-1 text-background-50/80 text-xs">
                  <span>View Products</span>
                  <i className="ri-arrow-right-up-line text-[10px]"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}